<div class="col">
  <div class="card shadow-sm">
    <div class="card-body">
      <div class="row row-cols-2" [ngClass]="{ 'pb-3': my_assets.length > 9 }">
        <div class="col">
          <h4 class="mb-3">{{ 'my_lines_and_devices' | translate }}</h4>
        </div>
        <div *ngIf="my_assets_ghost.length > 0" class="col d-flex justify-content-end card-filters">
          <div ngbDropdown class="d-inline-block mb-3 card-action" placement="bottom-right">
            <button ngbDropdownToggle type="button" class="btn btn-sm focus-visible outlined-btn">
              {{ 'filter' | translate }}
              <span class="badge text-bg-primary ms-1">{{ asset_status_filters_count }}</span>
            </button>
            <div ngbDropdownMenu class="dropdown-menu">
              <form [formGroup]="asset_status_filters" class="p-3">
                <!-- line filters -->
                <span class="mb-2 d-inline-block fw-bold">
                  {{ 'lines' | translate }}
                </span>
                <div class="mb-2">
                  <input
                    id="activeLines"
                    class="me-1 mt-0 form-check-input"
                    type="checkbox"
                    name="active"
                    value="active"
                    formControlName="active"
                  />
                  <label for="activeLines" class="form-check-label fw-light">
                    {{ 'active' | translate }}
                  </label>
                </div>
                <div class="mb-2">
                  <input
                    id="inactiveLines"
                    class="me-1 mt-0 form-check-input"
                    type="checkbox"
                    name="inactive"
                    value="inactive"
                    formControlName="inactive"
                  />
                  <label for="inactiveLines" class="form-check-label fw-light">
                    {{ 'inactive' | translate }}
                  </label>
                </div>
                <div>
                  <input
                    id="suspendedLines"
                    class="me-1 mt-0 form-check-input"
                    type="checkbox"
                    name="suspended"
                    value="suspended"
                    formControlName="suspended"
                  />
                  <label for="suspendedLines" class="form-check-label fw-light">
                    {{ 'suspended' | translate }}
                  </label>
                </div>

                <!-- device filters -->
                <span class="mt-3 mb-2 d-inline-block fw-bold">
                  {{ 'devices' | translate }}
                </span>
                <div>
                  <input
                    id="deviceNoLine"
                    class="me-1 mt-0 form-check-input"
                    type="checkbox"
                    name="devicenoline"
                    value="devicenoline"
                    formControlName="device_no_line"
                  />
                  <label
                    for="deviceNoLine"
                    class="form-check-label fw-light text-truncate"
                    title="{{ 'device_no_line' | translate }}"
                  >
                    {{ 'device_no_line' | translate }}
                  </label>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div
        *ngIf="my_assets.length > 0; else noAssetsView"
        class="row row-cols-1 row-cols-sm-2 row-cols-xl-3 g-3"
        [ngClass]="{ 'my-assets-section-scroll': my_assets.length > 9 }"
      >
        <div
          *ngFor="let asset of my_assets; index as i"
          class="col"
          [ngClass]="[0, 1, 2].includes(i) ? 'my-asset-scroll--' + i : ''"
        >
          <div
            as-link
            class="card h-100 elevate-white overflow-hidden asset-card"
            [attr.aria-label]="assetAriaLabel(asset)"
            (click)="openAssetOffCanvas(multiSimOffCanvas, asset)"
          >
            <div class="card-body card-items card-items-md">
              <div
                *ngIf="asset.line?.is_primary_contact"
                class="position-absolute top-0 start-0 asset-card__primary"
              >
                <span class="material-icons">verified</span>
              </div>
              <ng-container
                [ngTemplateOutlet]="assetActionsDropdown"
                [ngTemplateOutletContext]="{
                  asset: asset,
                  device_only: !hasLineId(asset.line) && hasDeviceId(asset.device)
                }"
              ></ng-container>
              <ts-dashboard-asset class="d-contents" [asset]="asset"></ts-dashboard-asset>
            </div>
            <div stop-click-propagation *ngIf="hasMultiSim(asset)" class="card-footer">
              <button
                type="button"
                class="d-flex justify-content-center btn text-capitalize fw-normal w-100"
                data-bs-toggle="offcanvas"
                data-bs-target="#multiSimOffCanvas"
                aria-controls="multiSimOffCanvas"
                (click)="openAssetOffCanvas(multiSimOffCanvas, asset)"
              >
                <span *ngIf="asset.multi_sim_type === multi_sim_types[0]">
                  <span class="material-icons lh-base">hub</span>&nbsp;
                  <span>
                    {{ 'additional_lines' | translate }}
                    ({{ asset.additional_lines?.length }})
                  </span>
                </span>
                <span
                  *ngIf="[multi_sim_types[1], multi_sim_types[6]].includes(asset.multi_sim_type)"
                >
                  <span class="material-icons lh-base">hub</span>&nbsp;
                  <span>
                    {{ 'additional_devices' | translate }}
                    ({{ asset.additional_devices?.length }})
                  </span>
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <ng-template #noAssetsView>
        <div class="row row-col-1">
          <div class="col my-5 text-center" [tds-data-loader]="{ key: 'user-assets', size: 'lg' }">
            <h2 class="text-secondary">
              {{ 'no_results_available' | translate }}
            </h2>
            <h6 *ngIf="my_assets_ghost.length > 0">
              {{ 'no_results_available_hint' | translate }}
            </h6>
          </div>
        </div>
      </ng-template>
    </div>
  </div>
</div>

<ng-template #assetActionsDropdown let-asset="asset" let-device_only="device_only">
  <div class="position-absolute top-0 end-0 text-decoration-none asset-actions">
    <div
      ngbDropdown
      *ngIf="!device_only; else deviceOnly"
      class="d-inline-block card-action"
      placement="bottom-right"
    >
      <button
        ngbDropdownToggle
        stop-click-propagation
        class="focus-visible neutral-btn"
        [attr.aria-label]="assetAriaLabel(asset) + ' Actions'"
        [attr.disabled]="isHiddenPrimaryOption(asset) ? 'true' : undefined"
      >
        <span class="material-icons color_black">more_vert</span>
      </button>
      <!-- Hidden -->
      <div ngbDropdownMenu [hidden]="isHiddenPrimaryOption(asset)">
        <button
          ngbDropdownItem
          stop-click-propagation
          class="focus-visible focus-visible-inset"
          (click)="confirmPrimaryLine(asset)"
        >
          {{ 'set_primary_contact' | translate }}
        </button>
      </div>
    </div>

    <ng-template #deviceOnly>
      <a stop-click-propagation class="disabled">
        <span class="material-icons">more_vert</span>
      </a>
    </ng-template>
  </div>
</ng-template>

<ng-template #multiSimOffCanvas let-offcanvas>
  <ts-multisim-offcanvas
    class="overflow-auto"
    [offcanvas_asset]="offcanvas_asset"
    [offcanvas]="offcanvas"
  ></ts-multisim-offcanvas>
</ng-template>
